import {
  IProductSlotState,
  isSeatedPssType,
} from "@/types/db/product-slot-state";
import { BookingStatus } from "@/types/db/product-slot-state";
import { releaseBookedSeats } from "@/api/seats-io/seats-io";
import { LogLevel, LogService } from "@/services/logging";
import Timeout from "await-timeout";

export async function releaseCancelledSeats(
  pssUpdates: IProductSlotState[]
): Promise<void> {
  const seatsToRelease: { seatId: string; eventKey: string }[] = [];

  for (const pssUpdate of pssUpdates) {
    if (
      pssUpdate.bookingStatus === BookingStatus.Canceled &&
      isSeatedPssType(pssUpdate.type)
    ) {
      if (pssUpdate.seat && pssUpdate.eventKey) {
        seatsToRelease.push({
          seatId: pssUpdate.seat,
          eventKey: pssUpdate.eventKey,
        });
        LogService.info(
          `Calling change-object-status to free the seat of the canceled PSS, pssUuid: ${pssUpdate.uuid}, seat: ${pssUpdate.seat}`
        );
      } else {
        // It seems we're trying to a free a seat that corresponds to a cancelledPSS that doesn't have a seat attached to it!
        LogService.info(
          `Trying to release a seat that corresponds to a canceled PSS that doesn't have a seat attached to it!`,
          { params: pssUpdate },
          LogLevel.Error
        );
      }
    }
  }

  if (!seatsToRelease.length) {
    return;
  }

  const maxAttempts = 3;
  let attempt = 0;
  let error: any = null;

  while (attempt < maxAttempts) {
    attempt++;

    try {
      LogService.info(
        `Attempting to release seats for cancelled PSSes (attempt ${attempt}/${maxAttempts}) for booking ${pssUpdates[0].bookingUuid}`,
        { params: { seatsCount: seatsToRelease.length, seats: seatsToRelease } }
      );

      await releaseBookedSeats(seatsToRelease);

      LogService.info(
        `Successfully released seats for cancelled PSSes after ${attempt} attempt(s) for booking ${pssUpdates[0].bookingUuid}`
      );
      error = null;
      break;
    } catch (err: any) {
      error = err;
      console.error({ err });
      LogService.info(
        `Attempt ${attempt}/${maxAttempts} failed to free seats for cancelled PSSes for booking ${pssUpdates[0].bookingUuid}`,
        {
          params: {
            error: err,
          },
        },
        LogLevel.Error
      );

      // If this was the last attempt, don't wait before breaking
      if (attempt < maxAttempts) {
        await Timeout.set(1000);
      }
    }
  }

  if (error && attempt === maxAttempts) {
    console.error({ error, attempt });
    LogService.info(
      `FINAL FAILURE: Unable to free seats for cancelled PSS after ${maxAttempts} attempts for booking ${pssUpdates[0].bookingUuid}`,
      {
        params: {
          error,
          seatsToRelease,
        },
      },
      LogLevel.Error
    );
  }
}
